import styled from "styled-components";

const PageWrapper = styled.div`
  .react-form-inputs {
    border-radius: 1px !important;
    font-size: 14px !important;
    border: 1px solid red !important;
  }
  .box-height {
    height: 200px;
    overflow-x: hidden;
    overflow-y: scroll;
    background-color: #80808014;
    border-radius: 10px;
    /* Firefox — always show a visible thin scrollbar */
    scrollbar-width: thin;
    scrollbar-color: #8a8a8a #d8d8d8;

    /* Chromium / Safari — force a visible scrollbar track */
    &::-webkit-scrollbar {
      width: 10px;
      -webkit-appearance: none;
    }
    &::-webkit-scrollbar-track {
      background: #d8d8d8;
      border-radius: 0 10px 10px 0;
    }
    &::-webkit-scrollbar-thumb {
      background: #8a8a8a;
      border-radius: 6px;
      border: 2px solid #d8d8d8;
      min-height: 40px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #6a6a6a;
    }
  }
  label {
    font-weight: 600;
  }
`;

export default PageWrapper;
